import PropTypes from 'prop-types'
import Button from '../../Nodes/Button'
import Icon from '../../Nodes/Icon'
import { createLengthArray, numberSortFn } from '../../../utilities'

const paginator = (props) => {
    const pageCount = Math.ceil(props.count / props.pageSize)

    const pages = () => {
        const maxLength = 9
        if (pageCount <= maxLength)
            return createLengthArray(pageCount)

        const { page } = props
        const pages = [page]

        while (pages.length < maxLength) {
            const min = Math.min(...pages) - 1
            const max = Math.max(...pages) + 1

            if (max <= pageCount)
                pages.push(max)

            if (pages.length < maxLength && min > 0)
                pages.push(min)
        }

        return pages.sort(numberSortFn)
    }

    const renderNumber = page => {
        let className = 'paginator__item'
        if ((!props.page && page === 1) || (props.page === page)) 
            className += ' paginator__item--selected'

        return <span key={'paginator__item--' + page} className={className} onClick={() => props.callback(page)}>{page}</span>
    }

    return pageCount > 1 ?
        (<div className="paginator">
            { props.page > 1 && <Button onClick={() => props.callback(props.page - 1)}><Icon>keyboard_arrow_left</Icon></Button> }
            { pages().map(x => renderNumber(x)) }
            { props.page < pageCount && <Button onClick={() => props.callback(props.page + 1)}><Icon>keyboard_arrow_right</Icon></Button>}
        </div>) : null
}

paginator.propTypes = {
    page: PropTypes.number,
    count: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    callback: PropTypes.func.isRequired
}

export default paginator